"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _unset2 = _interopRequireDefault(require("lodash/unset"));
var _index = require("../../constants/index.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var PAGE_LOADED = _index.eventTypes.PAGE_LOADED;
var cleanWebPageDetails = function cleanWebPageDetails(event) {
  var eventType = (0, _get2["default"])(event, 'event');
  if (eventType === PAGE_LOADED) return event;
  (0, _unset2["default"])(event, 'xdm.web.webPageDetails.pageViews');
  (0, _unset2["default"])(event, 'xdm.web.webPageDetails._telus.customPageViews');
  return event;
};
var _default = exports["default"] = cleanWebPageDetails;